import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const Spinner = () => (
  
  <Box sx={{ display: 'flex', width: '100%', height:  window.location.pathname.includes('rename-fragrance-fields') ? '' : '100vh', justifyContent: 'center', alignItems: 'center' }}>
    <CircularProgress />
  </Box>
);

export default Spinner;
